import moment from "moment"

/**
 * Format any date value as DD-MM-YYYY.
 * Returns "" for null / undefined / invalid dates.
 */
export const formatDate = (value) => {
  if (!value) return ""
  const m = moment(value)
  return m.isValid() ? m.format("DD-MM-YYYY") : ""
}

/**
 * Format any date value as DD-MM-YYYY HH:mm (with time).
 */
export const formatDateTime = (value) => {
  if (!value) return ""
  const m = moment(value)
  return m.isValid() ? m.format("DD-MM-YYYY HH:mm") : ""
}
